import { render, staticRenderFns } from "./eight_items_stipulate_table.vue?vue&type=template&id=1bed6bf5&scoped=true"
import script from "./eight_items_stipulate_table.vue?vue&type=script&lang=js"
export * from "./eight_items_stipulate_table.vue?vue&type=script&lang=js"
import style0 from "./eight_items_stipulate_table.vue?vue&type=style&index=0&id=1bed6bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed6bf5",
  null
  
)

export default component.exports